// crewbit-admin/src/lib/scheduleLayout.ts
//
// Schedule Module Phase C C1.5 — pure layout-mode resolver. Body byte-equivalent
// to mobile crewbit-mobile/lib/scheduleLayout.ts modulo import path
// (per feedback_admin_pair_must_match_mobile_body.md parity rule).
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §C.6 + §0.10.

export type DayLayoutMode = 'single-resource' | 'staff-columns';

/**
 * Canvas feature-flag shape. Standalone since Industry Engine Phase 1c retired
 * the `schedule_industry_defaults` table — feature gating now derives from the
 * cluster resolver. Body byte-equivalent to mobile crewbit-mobile/lib/scheduleLayout.ts.
 */
export interface ScheduleIndustryFeatureFlags {
  recurring_badge?: boolean;
  staff_columns?: boolean;
  route_lens_enabled?: boolean;
}

export interface ResolveDayLayoutInput {
  featureFlags: ScheduleIndustryFeatureFlags | null | undefined;
  businessTier?: string | null;
  operatorCount?: number;
}

export function resolveDayLayout(input: ResolveDayLayoutInput): DayLayoutMode {
  const { featureFlags, businessTier, operatorCount } = input;
  if (featureFlags?.staff_columns === true && businessTier === 'business' && (operatorCount ?? 0) > 1) {
    return 'staff-columns';
  }
  return 'single-resource';
}
